export const CoreSelectionsName = 'CoreSelections';
